import { render, staticRenderFns } from "./LogisticWorkplacePage.vue?vue&type=template&id=049424db&"
import script from "./LogisticWorkplacePage.vue?vue&type=script&lang=ts&"
export * from "./LogisticWorkplacePage.vue?vue&type=script&lang=ts&"
import style0 from "./LogisticWorkplacePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports